var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipmentIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 14.8637V26.8642C43.9997 29.8643 42.9996 32.3644 41.2396 34.1245C39.4995 35.8646 36.9994 36.8646 33.9993 36.8646V41.1248C33.9993 42.7248 32.2192 43.6849 30.8992 42.8049L21.9988 36.8646H17.7586C17.9186 36.2646 17.9986 35.6446 17.9986 35.0045C17.9986 32.9644 17.2186 31.0844 15.9385 29.6643C14.4985 28.0243 12.3584 27.0042 9.99829 27.0042C7.7582 27.0042 5.71813 27.9243 4.25807 29.4243C4.07806 28.6243 3.99805 27.7642 3.99805 26.8642V14.8637C3.99805 8.86344 7.99821 4.86328 13.9985 4.86328H33.9993C39.9995 4.86328 43.9997 8.86344 43.9997 14.8637Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35C18 35.64 17.92 36.26 17.76 36.86C17.58 37.66 17.26 38.44 16.84 39.12C15.46 41.44 12.92 43 10 43C7.94 43 6.07999 42.2199 4.67999 40.9399C4.07999 40.4199 3.55997 39.8 3.15997 39.12C2.41997 37.92 2 36.5 2 35C2 32.84 2.86001 30.86 4.26001 29.42C5.72001 27.92 7.76 27 10 27C12.36 27 14.5 28.02 15.94 29.66C17.22 31.08 18 32.96 18 35Z",
    fill: "#A020FF",
    stroke: "#A020FF",
    strokeWidth: 2.52632,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9795 34.9648H7.01953",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 32.0469V38.0269",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 17.1445H32.5716",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4287 21.4297H32.5716",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentIcon2);
export default __webpack_public_path__ + "static/media/equipmentIcon2.cd851827af738dd5e2de281638d38cf5.svg";
export { ForwardRef as ReactComponent };